var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.sideMonitoring
    ? _c(
        "div",
        {
          class: ["connection-box", "bottom-md", _vm.mobileBoxClass],
          attrs: { name: "step4-check-side" },
        },
        [
          _c("div", { staticClass: "before" }, [
            _c("div", { staticClass: "row qr-ol" }, [
              _c("div", { staticClass: "col-auto" }, [
                _c("img", { ref: "qr", attrs: { alt: "QR코드" } }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col ml-md" }, [
                _c("ol", [
                  _c("li", [
                    _c("span", [_vm._v("1")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("preRegistration.step4.side.guide.row1.text1")
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", [_vm._v("2")]),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("preRegistration.step4.side.guide.row2")
                        ) +
                        "\n          "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "after" }, [
            _c("div", { staticClass: "video-box" }, [
              _c("div", { staticClass: "text-item video-text" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("preRegistration.step4.side.ready"))),
                ]),
              ]),
              _vm._v(" "),
              _c("video", {
                ref: "mobile",
                staticClass: "face_video reverse",
                attrs: {
                  autoplay: "",
                  playsinline: "",
                  muted: "",
                  id: "mobile",
                },
                domProps: { muted: true },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cam-print-done" }, [
            _c("div", { staticClass: "icon-confirm" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("preRegistration.step4.side.connectComplete"))
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }